import { FormEvent, useState } from "react";
import { Head, Link, router } from "@inertiajs/react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

interface LoginProps {
  errors?: {
    email?: string;
    password?: string;
  };
  rememberable?: boolean;
}

export default function Login({ errors = {}, rememberable = true }: LoginProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    router.post(
      "/admins/sign_in",
      {
        admin: {
          email,
          password,
          remember_me: rememberMe,
        },
      },
      {
        onFinish: () => setLoading(false),
      }
    );
  };

  return (
    <>
      <Head title="تسجيل الدخول" />
      <Card>
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">تسجيل الدخول</CardTitle>
          <CardDescription className="text-center">
            أدخل بريدك الإلكتروني وكلمة المرور للدخول
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">البريد الإلكتروني</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
              {errors?.email && <p className="text-sm text-destructive">{errors.email}</p>}
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">كلمة المرور</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              {errors?.password && <p className="text-sm text-destructive">{errors.password}</p>}
            </div>

            {rememberable && (
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="remember"
                  checked={rememberMe}
                  onCheckedChange={(checked) => setRememberMe(checked as boolean)}
                />
                <Label htmlFor="remember" className="text-sm font-normal cursor-pointer">
                  تذكرني
                </Label>
              </div>
            )}

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "جاري تسجيل الدخول..." : "تسجيل الدخول"}
            </Button>

            <div className="text-center space-y-2 text-sm">
              <Link href="/users/password/new" className="text-muted-foreground hover:text-primary">
                نسيت كلمة المرور؟
              </Link>
              <div>
                <span className="text-muted-foreground">لا تملك حساباً؟ </span>
                <Link href="/admins/sign_up" className="text-primary hover:underline font-medium">
                  إنشاء حساب جديد
                </Link>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
    </>
  );
}
